var map = {
	"./addToBlacklist.html": "4whP",
	"./channelsWarningModal.html": "MAft",
	"./contactSupport.html": "lV3D",
	"./limit-title/limit.title": "3w9C",
	"./limit-title/limit.title.html": "Qody",
	"./limit-title/limit.title.ts": "3w9C",
	"./modal.html": "P5VN",
	"./modal.service": "Cjx9",
	"./modal.service.ts": "Cjx9",
	"./planLimitsUsers.html": "snap",
	"./planLimitsUsersController": "9e8s",
	"./planLimitsUsersController.ts": "9e8s",
	"./transfer.data.service": "njLB",
	"./transfer.data.service.ts": "njLB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lu6/";